import { getUserProfile } from '../../../data/repositories/userRepository.js';

export const fetchUserProfile = () => getUserProfile();
